






















































































import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
import { authenticationService } from "@/_services";

@Component
export default class DocumentsSorting extends Vue {
  private items: any[] = [];
  dateToSearch = new Date();
  defaultSortDir = "asc";
  user: null | undefined;
  draggingRow: null;
  draggingRowIndex: null;
  draggingColumn: null;
  draggingColumnIndex: null;
  dateFormat = moment(this.dateToSearch).locale("hr-HR").format('DD.MM.YYYY.');
  monthNames = moment.localeData("hr-HR").months();
  dayNames = moment.localeData("hr-HR").weekdaysShort();
  showSubmitButton: boolean = true;
  isSubmitting: boolean = false;
  submitResult: boolean = false;
  isSubmitted: boolean = false;


  created() {
    authenticationService.currentUser.subscribe((x: null) => {
      this.user = x;
    });
  }

  async mounted() {
    this.load();
  }

  @Watch("$route")
  onRouteChange() {
    this.load();
  }

  @Watch("dateToSearch", { deep: true })
  onQueryChange() {
    this.search();
  }

  async load() {
    const params = new URLSearchParams();
    params.append('planned_publishing_date', moment(new Date()).format("YYYY-MM-DD"))

    this.items = (
      await axios.get<[]>("/document", {
        params: params,
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    for (let item of this.items) {
      item.frequency = this.getShortenedFrequencyString(item.frequency);
    }
  }

  async search() {
    const params = new URLSearchParams();
    params.append('planned_publishing_date', moment(this.dateToSearch).format("YYYY-MM-DD"))
    this.items = (
      await axios.get<[]>("/document", {
        params: params,
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    for (let item of this.items) {
      item.frequency = this.getShortenedFrequencyString(item.frequency);
    }
  }

  getShortenedFrequencyString(frequency) {
    switch (frequency) {
      case 'mjesečno':
        return 'M';

      case 'tromjesečno':
        return 'T';

      case 'polugodišnje':
        return 'PG';

      case 'godišnje':
        return 'G';

      case 'dvogodišnje':
        return 'DG';

      case 'weekly':
        return 'TJ';
    }
  }

  getUppercaseName(name) {
    const capitalizedFirst = name[0].toUpperCase();
      const rest = name.slice(1);

      return capitalizedFirst + rest;
  }

  dragstart(payload) {
        this.draggingRow = payload.row
        this.draggingRowIndex = payload.index
        payload.event.dataTransfer.effectAllowed = 'copy'
  }

  dragover(payload) {
    payload.event.dataTransfer.dropEffect = 'copy'
    payload.event.target.closest('tr').classList.add('is-selected')
    payload.event.preventDefault()
  }

  dragleave(payload) {
    payload.event.target.closest('tr').classList.remove('is-selected')
    payload.event.preventDefault()
  }

  drop(payload) {
    payload.event.target.closest('tr').classList.remove('is-selected')
    const droppedOnRowIndex = payload.index;

    if (droppedOnRowIndex >= this.items.length) {
        var k = droppedOnRowIndex - this.items.length + 1;
        while (k--) {
            this.items.push(undefined);
        }
    }
    this.items.splice(droppedOnRowIndex, 0, this.items.splice(parseInt(this.draggingRowIndex || '{}'), 1)[0]);

    this.items.forEach((item, index) =>{
      item.daily_sort_order = index + 1;

    });

    this.items.sort((a, b) => {
      if (a["daily_sort_order"] < b["daily_sort_order"]) return -1;
      if (a["daily_sort_order"] > b["daily_sort_order"]) return 1;
      return 0;
    });   
  }

  async submit(){
    try {
      await axios.post(
        `/document/update-range`,
        this.items,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        }
      );
      this.isSubmitted = true;
      this.submitResult = true;
      this.showSubmitButton = true;
      
      setTimeout(() => {
        this.submitResult = false; // Hide the div after 3 seconds
      }, 3000);
    }
    catch {
      this.isSubmitted = true;
      this.submitResult = false;
    }
  }
}
